module.exports = __webpack_public_path__ + "static/img/JohannesburgCanninah.d9dee03.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/our-people/JohannesburgCanninah.jpg
// module id = UTdo
// module chunks = 0